export default __webpack_public_path__ + "static/media/arrow_left.b0d06033.svg";